// 取票流程
<template>
    <div>
        <div class="side-btn" @click="receiveTicket">取 单</div>
        <tipsDialog :dialogVisible="platformDialogVisible" :tipsMessage="platformText" >
            <div class="btn-group" v-if="!platformLoading">
                <div class="confirm-btn" @click="trayUp">纸仓上升</div>
            </div>
        </tipsDialog>
        <errorDialog :errorMessage="errorMessage" :dialogVisible="errorDialogVisible">
            <div class="btn-group">
                <div class="cancle-btn" @click="() => {errorDialogVisible = false}">确定</div>
            </div>
        </errorDialog>
    </div>
    
</template>

<script>
import tipsDialog from '@/components/tipsDialog'
import errorDialog from '@/components/errorDialog'
export default {
    components: {
        tipsDialog,
        errorDialog
    },
    data(){
        return{
            platformDialogVisible: false,
            platformText: '',
            platformLoading: false,
            errorMessage: '',
            errorDialogVisible: false
        }
    },
    methods:{
        // 纸仓下降
        async receiveTicket() {
            let paperBinDoorOpen = false
            let siuResult = await this.siu.getInput();
            console.log("siu_getInput:" + JSON.stringify(siuResult));
            //{ "input" : [ { "port" : "paper_bin_door", "value" : 1 } ], "message":"","resu1t" :0, "device”:"siu" }
            if(siuResult.result == 0) {
                let inputList = siuResult.input;
                for(let i = 0; i < inputList.length; i++) {
                    let inputObj = inputList[i];
                    if(inputObj.port == 'paper_bin_door') { //纸仓门传感器
                        let inputValue = inputObj.value;
                        if(inputValue == 1) { //纸仓门处于打开状态
                            paperBinDoorOpen = true;
                        }
                    }
                }
                if(paperBinDoorOpen) { //纸仓门处于打开状态
                    // this.$alert('纸仓门未关闭，请先关闭纸仓门，再操作', '设备异常', {
                    //     type: 'warning',
                    //     showClose: false,
                    //     showCancelButton: false,
                    //     confirmButtonText: '确定',
                    //     callback: async action => {
                    //         console.log('action', action)
                    //     }
                    // });
                    this.errorMessage = '纸仓门未关闭，请先关闭纸仓门，再操作'
                    this.errorDialogVisible = true
                    return ;
                }
            } else {
                this.errorMessage = '智能电源故障，请维修'
                this.errorDialogVisible = true
            }

            this.platformText = '升降台下降中，请稍后...'
            this.platformDialogVisible = true;
            this.platformLoading = true

            let result = await this.ist.call("tray_down");
			console.log("tray_down:" + JSON.stringify(result));
			if(result.result == 0){
				console.log("升降台下降成功");
                this.platformText = '将文件取走后,点击升降台上升'
                this.platformLoading = false
			}else{
                this.platformDialogVisible = false;
                let message = '升降台下降发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                this.errorMessage = message
                this.errorDialogVisible = true
			}
        },

        // 纸仓上升
        async trayUp() {
            let paperBinDoorOpen = false;
            let siuResult = await this.siu.getInput();
            console.log("siu_getInput:" + JSON.stringify(siuResult));
            //{ "input" : [ { "port" : "paper_bin_door", "value" : 1 } ], "message":"","resu1t" :0, "device”:"siu" }
            if(siuResult.result == 0) {
                let inputList = siuResult.input;
                for(let i = 0; i < inputList.length; i++) {
                    let inputObj = inputList[i];
                    if(inputObj.port == 'paper_bin_door') { //纸仓门传感器
                        let inputValue = inputObj.value;
                        if(inputValue == 1) { //纸仓门处于打开状态
                            paperBinDoorOpen = true;
                        }
                    }
                }
                if(paperBinDoorOpen) { //纸仓门处于打开状态
                    // this.$alert('纸仓门未关闭，请先关闭纸仓门，再操作', '设备异常', {
                    //     type: 'warning',
                    //     showClose: false,
                    //     showCancelButton: false,
                    //     confirmButtonText: '确定',
                    //     callback: async action => {
                    //         console.log('action', action)
                    //     }
                    // });
                    this.errorMessage = '纸仓门未关闭，请先关闭纸仓门，再操作'
                    this.errorDialogVisible = true
                    return ;
                }
            } else {
                this.errorMessage = '智能电源故障，请维修'
                this.errorDialogVisible = true
            }

            this.platformDialogVisible = false;

            let result = await this.ist.call("tray_up");
			console.log("tray_up:" + JSON.stringify(result));
			if(result.result == 0){
				console.log("升降台上升成功");
			} else {
                let message = '升降台下降发生未知错误,请联系工作人员处理,错误码:' + JSON.stringify(result)
                this.errorMessage = message
                this.errorDialogVisible = true
			}
        },
    }
}
</script>
<style lang="less" scoped>
    .side-btn {
        position: absolute;
        top:192px;
        right: 30px;
        width: 200px;
        height: 66px;
        line-height: 66px;
        font-size: 28px;
        text-align: center;
        color: #F7636E;
        background: #FFEEF1;
        border: 2px solid #F7636E;
        border-right: none;
        letter-spacing: 1px;
        border-radius: 8px 0px 0px 8px;
    }
</style>

